import React, { Component } from 'react';
import { Row } from 'react-bootstrap';
import FilteredServicesColumn from './FilteredServicesColumn';
import FilteredServicesCard from './FilteredServicesCard';
import "../../css/services.css";

class FilteredServices extends Component {

    constructor(props) {
        super(props);
        this.state = { isColumnView: true };
        this.onFilteredServicesCardClick = this.onFilteredServicesCardClick.bind(this);

    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    onFilteredServicesCardClick(label) {

        this.props.actions.selectService(label);
    }

    toggleViewCards(isThreeUp, event) {
        event.stopPropagation();
        this.setState({ isColumnView: isThreeUp });
    }

    renderFilteredServices() {
        let { availableServices = [], selectedGuestDetails = {}, PaymentDetails = {} } = this.props.services;
        let { isMobileView } = this.props;
        let { ShipboardCurrencyCode = 'USD' } = PaymentDetails;

        if (!availableServices || availableServices.length <= 0)
            return <h3 className='no-result-banner d-none d-md-block font-size-p8 gotham-xn-book'>0 Results Found</h3>;


        let cardItems = availableServices.map((item) => (
            <li> <FilteredServicesCard ShipboardCurrencyCode={ShipboardCurrencyCode} selectedGuestDetails={selectedGuestDetails} onCardClick={this.onFilteredServicesCardClick} service={item} /></li>
        ));

        let cardRows = (
            <ul className=' filterd-list  list-style'>
                {cardItems}
            </ul>
        )

        let CardColumns = (
            <ul style={{ paddingTop: '15px' }} className='services-row row  row-eq-height list-style' >
                {availableServices.map((item) => (
                    <li className='column-container bottom-spacing-30 col-md-4 col-xs-12 col-sm-12' >
                        <FilteredServicesColumn ShipboardCurrencyCode={ShipboardCurrencyCode} selectedGuestDetails={selectedGuestDetails} onCardClick={this.onFilteredServicesCardClick} service={item} />
                    </li>))
                }
            </ul>
        );

        if (isMobileView)
            return CardColumns

        return (this.state.isColumnView) ? CardColumns : cardRows;
    }


    render() {
        let { isMobileView } = this.props;
        return (
            <section className='floating-cards container white-bg filtered-services-container' data-test-id="cards-container">
                {isMobileView ?
                    null
                    : <>
                        <Row className='services-row'>
                            <div className='display-as-container'>
                                <span className='font-size-p2 gotham-xn-medium' data-test-id="display-as">Display as :</span>
                                <button aria-label="Display Three up" className='icon-three-up-container button-link text-center' onClick={this.toggleViewCards.bind(this, true)}>
                                    <svg id="icon-three-up" className={(this.state.isColumnView ? 'selected-svg-icon' : 'unselected-svg-icon')} data-test-id="three-up" viewBox="0 0 24 24" width="100%" height="100%">
                                        <title>Three up</title>
                                        <path style={{ fillRule: 'evenodd', clipRule: 'evenodd' }} d="M14,16h5v6h-5V16z M14,9h5v6h-5V9z M14,2h5v6h-5V2z M8,16h5v6H8V16z M8,9h5v6H8V9z M8,2h5v6H8V2z M2,16h5v6H2V16z M2,9h5v6H2V9z M2,2h5v6H2V2z M21,1v22v1H0v-1V1V0h21V1z M20,1H1v22h19V1z"></path>
                                    </svg>
                                </button>
                                <button aria-label="Display List" className='icon-three-up-container button-link text-center' onClick={this.toggleViewCards.bind(this, false)}>
                                    <svg id="icon-one-up" className={(!this.state.isColumnView ? 'selected-svg-icon' : 'unselected-svg-icon')} data-test-id="one-up" viewBox="0 0 24 24" width="100%" height="100%">
                                        <title>One Up</title>
                                        <rect x="2" y="2" width="17" height="5"></rect>
                                        <rect x="2" y="9" width="17" height="5"></rect>
                                        <rect x="2" y="16" width="17" height="5"></rect>
                                        <path d="M0,0v1v22v1h21v-1V1V0H0z M20,23H1V1h19V23z"></path>
                                    </svg>
                                </button>
                            </div>
                        </Row>
                    </>}

                {this.renderFilteredServices()}

            </section>
        );
    }
}



export default FilteredServices;